import { render, staticRenderFns } from "./ProductListContent.vue?vue&type=template&id=2f2716d7&scoped=true&"
import script from "./ProductListContent.vue?vue&type=script&lang=ts&"
export * from "./ProductListContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductListContent.vue?vue&type=style&index=0&id=2f2716d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2716d7",
  null
  
)

export default component.exports